/**
 * @description Resolves the visitor's region via the /cf/region CloudFront Function.
 * @filename viewer-region.ts
 */

export interface ViewerRegion {
  country: string;
  subdivision: string | null;
}

const UNKNOWN_REGION: ViewerRegion = { country: "", subdivision: null };

/**
 * Attaches a user's region and subregion, if not exists, then defaults to auto scale policy in index
 */
export async function resolveViewerRegion(): Promise<ViewerRegion> {
  try {
    const response = await fetch("/cf/region", { credentials: "omit" });
    if (!response.ok) {
      return UNKNOWN_REGION;
    }

    const data = await response.json();
    return {
      country: typeof data?.region === "string" ? data.region : "",
      subdivision: typeof data?.subdivision === "string" ? data.subdivision : null,
    };
  } catch {
    return UNKNOWN_REGION;
  }
}
